export interface BottomBars {
  icons: Icon[]
}

export enum DeviceType {
  "android" = "0",
  "ios" = "1",
  "web" = "3",
  "food_miniapp" = "4",
}

interface Icon {
  id: number
  name: string
  type: string
  active_image: string
  inactive_image: string
  deep_link: string
  service_name: string
  promoted: number
  promoted_image: string
  title_vi: string
  title_en: string
}
